

























































































import { DataProxy } from 'apollo-cache';
import gql from 'graphql-tag';
import * as R from 'ramda';
import Vue from 'vue';

import { Retailer } from '@/core/entity';

import RetailerForm from './Form.vue';
import { listRetailerQL } from './graphql';

export default Vue.extend({
  components: {
    'form-retailer': RetailerForm,
  },

  apollo: {
    retailers: {
      query: listRetailerQL,
      variables() {
        return { country: this.country };
      },
      fetchPolicy: 'cache-first',
    },
  },

  data() {
    const retailerId = this.$route.params.retailer_id;
    return {
      country: 'my',
      isDrawerVisible: retailerId ? true : false,
      loading: false,
    };
  },

  computed: {
    retailerId(): string {
      return this.$route.params.retailer_id;
    },

    drawerTitle(): string {
      return this.retailerId ? 'Edit retailer' : 'Create a new retailer';
    },
  },

  watch: {
    retailerId(newVal: string | null) {
      this.isDrawerVisible = !!newVal;
    },
  },

  methods: {
    handleDelete(id: string) {
      this.$coreApp.retailer.remove(
        id,
        this.presenter(
          'Retailer deleted.',
          'Unable to delete retailer:',
          false,
        ),
        this.updater,
      );
    },

    handleSave(val: any) {
      const { retailerId } = this;
      if (retailerId) {
        // edit retailer
        this.$coreApp.retailer.update(
          retailerId,
          val.name,
          val.country,
          val.desId,
          val.file as File | string,
          this.presenter(
            'Retailer updated.',
            'Unable to update retailer:',
            false,
          ),
          this.updater,
        );
      } else {
        // create retailer
        this.$coreApp.retailer.create(
          val.name,
          val.country,
          val.desId,
          val.file as File,
          this.presenter(
            'Retailer created.',
            'Unable to create retailer:',
            true,
          ),
          this.updater,
        );
      }
    },

    hideDrawer() {
      this.isDrawerVisible = false;
      if (this.retailerId) {
        this.$router.back();
      }
    },

    presenter(success: string, failure: string, isNew: boolean) {
      return (err: Error | null, result: Retailer | null, loading: boolean) => {
        this.loading = loading;
        if (err) {
          this.$message.error(`${failure} ${err.message}`);
        } else if (result !== null) {
          this.$message.success(success);

          if (isNew) {
            this.isDrawerVisible = false;
          } else {
            this.$router.push({ name: 'retailer.list' });
          }
        }
      };
    },

    showDrawer() {
      this.isDrawerVisible = true;
    },

    getCountry(id: any) {
      switch (id) {
        case 'my':
          return '/img/fl-my-sq.svg';
        case 'sg':
          return '/img/fl-sg-sq.svg';
        case 'id':
          return '/img/fl-id-sq.svg';

        default:
          return '/img/fl-my-sq.svg';
      }
    },

    updater(
      store: DataProxy,
      res: {
        data: {
          newRetailer?: Retailer;
          removeRetailer?: Retailer;
          updateRetailer?: Retailer;
        };
      },
    ) {
      const retailer = (res.data.updateRetailer ||
        res.data.newRetailer ||
        res.data.removeRetailer) as Retailer;

      const data: { retailers: Retailer[] } | null = store.readQuery({
        query: listRetailerQL,
        variables: { country: this.country },
      });

      if (res.data.newRetailer) {
        // created
        data!.retailers = R.prepend(retailer, data!.retailers);
      } else if (res.data.updateRetailer) {
        // updated
        const idx = R.findIndex(R.propEq('id', retailer.id))(data!.retailers);
        if (idx === -1) {
          // tslint:disable-next-line no-console
          console.error('Unable to find retailer in retailers');
          return;
        }

        const previous = data!.retailers[idx];
        data!.retailers = R.update(
          idx,
          {
            ...previous,
            ...retailer,
          },
          data!.retailers,
        );
      } else {
        // removed
        data!.retailers = R.reject(
          R.propEq('id', retailer.id),
          data!.retailers,
        );
      }

      store.writeQuery({
        query: listRetailerQL,
        variables: { country: this.country },
        data,
      });
    },
  },
});
